import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=1ba68d53&scoped=true&"
import script from "./AppointmentDetail.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDetail.vue?vue&type=style&index=0&id=1ba68d53&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba68d53",
  null
  
)

export default component.exports